import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AuthPolicies } from '../../auth/auth-policies';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-master-data',
  standalone: true,
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterModule],
})
export class MasterDataComponent implements OnInit {
  dashboardCards: { title: string; description: string; route: string }[] = [];
  getMasterDataApiCallStatus = 'COMPLETED_SUCCESFULLY';

  constructor(private readonly authPolicies: AuthPolicies) {}

  ngOnInit(): void {
    this.buildDashboardCards();
  }

  private buildDashboardCards(): void {
    const allCards = [
      {
        title: 'Shop Management',
        description: 'Manage shop details, locations, and configurations.',
        route: '/master-data/shop-management',
        visible: this.authPolicies.canViewShopManagement && environment.Features.EnableShopManagementAddEdit,
      },
      {
        title: 'Parts Management',
        description: 'Manage parts, categories, and inventory details.',
        route: '/master-data/parts-management',
        visible: this.authPolicies.canViewPartManagement && environment.Features.EnablePartsManagement,
      },
      {
        title: 'Contract Rates and Discount',
        description: 'Manage labour rates, material rates, and OEM discounts.',
        route: '/master-data/shop-contract',
        visible: this.authPolicies.canViewShopContract && environment.Features.EnableContractRatesAndDiscount,
      },
      {
        title: 'Damage Code',
        description: 'Manage damage codes and damage types.',
        route: '/master-data/damage-code',
        visible: this.authPolicies.canViewDamageCode && environment.Features.EnableDamageCode,
      },
      {
        title: 'Repair Code Part Association',
        description: 'Manage repair parts and their details.',
        route: '/master-data/repair-part',
        visible: this.authPolicies.canViewRepairPart && environment.Features.EnableRepairPart,
      },
      {
        title: 'Repair Code',
        description: 'Manage repair codes and their configurations.',
        route: '/master-data/repair-code',
        visible: this.authPolicies.canViewRepairCode && environment.Features.EnableRepairCode,
      },
      {
        title: 'Repair Code Exclusion',
        description: 'Manage mutually exclusive repair codes by mode.',
        route: '/master-data/repair-code-exclusion',
        visible: this.authPolicies.canViewRepairCodeExclusion && environment.Features.EnableRepairCodeExclusion,
      },
      {
        title: 'Part Code Exclusion',
        description: 'Manage excluded parts by repair mode.',
        route: '/master-data/part-exclusion',
        visible: this.authPolicies.canViewPartExclusion && environment.Features.EnablePartExclusion,
      },
      {
        title: 'Repair Code Grade Mapping',
        description: 'Manage repair code grade mappings and grade applicability.',
        route: '/master-data/container-grade-repair-code',
        visible: this.authPolicies.canViewContainerGradeRepairCode && environment.Features.EnableContainerGradeRepairCode,
      },
      {
        title: 'Repair Location',
        description: 'Manage repair location codes and descriptions.',
        route: '/master-data/repair-location',
        visible: this.authPolicies.canViewRepairLocation && environment.Features.EnableRepairLocation,
      },
      {
        title: 'Repair Mode',
        description: 'Manage repair mode codes and descriptions.',
        route: '/master-data/repair-mode',
        visible: this.authPolicies.canViewRepairMode && environment.Features.EnableRepairMode,
      },
    ];

    this.dashboardCards = allCards.filter((card) => card.visible).map(({ title, description, route }) => ({ title, description, route }));
  }
}
